import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import historicsFields from '../../../fields/historicsFields';
import HISTORICS_USER_TYPE from '../../../enums/HistoricsUsersType';
import Entity from '@/common-utils/components/renders/entity/Entity';

export const columnsUsersHistoricsId = 'usersHistorics';

export const columnsUsersHistorics = (headerPackage) => {
    return ([
        // ColumnSelection
        generateColumnDefByField({
            field: historicsFields.USERS_HISTORICS.EMAIL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: historicsFields.USERS_HISTORICS.TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const type = HISTORICS_USER_TYPE[cell.getValue(historicsFields.USERS_HISTORICS.TYPE.key)];
                return (
                    type &&
                    <Entity entity={type.entity} namespace={type.namespace} />
                );
            }
        })
    ]).filter(col => !!col);
};